// extracted by mini-css-extract-plugin
export default {"wrapper":"Mydocs_wrapper__dop5-","mydocs":"Mydocs_mydocs__8pY2e"};